import { ref } from "vue";
import { defineStore } from "pinia";

export const usePopupState = defineStore("popupStore", () => {
  const component = ref(null);
  const isVisible = ref(false);
  const data = ref("");

  function showPopup(payload: any) {
    component.value = payload.component;
    isVisible.value = true;
    data.value = payload.data;
  }

  function hidePopup() {
    isVisible.value = false;
    component.value = null;
  }

  return {
    component,
    isVisible,
    showPopup,
    hidePopup,
    data,
  };
});
